import { Component, Input, input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StaticFeatureFlagService } from '@hrra/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { changeLanguage } from 'src/app/root-store/actions';
import { selectBlogEnabled, selectBlogPortalUrl, selectCustomerPortalUrl, selectFavoriteAnnouncementsCount } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-header-public',
    templateUrl: './header-public.component.html',
    styleUrls: ['./header-public.component.scss'],
    standalone: false
})
export class HeaderPublicComponent implements OnInit {

  @Input() currentLanguage: string;
  @Input() languages: string[] = [];
  @Input() providerWebsiteId: number;
  showAppsLauncher = input(true);
  favoritesIcon = input('assets/icons/header-2-heart.svg');

  isBurgerMenuOpen = false;
  isLanguageMenuOpen = false;
  isEmployersMenuOpen = false;

  // the theme toggle stays hidden until theme switching is implemented
  isDarkModeEnabled = false;

  // 3x3 dot grid of the apps launcher, rendered purely from css
  readonly appsLauncherDots = Array(9);

  favCount$: Observable<number>;
  customerPortalUrl$: Observable<string>;

  blogUrl$: Observable<string>;
  blogEnabled$: Observable<boolean>;

  public isActive(url: string){
    return this.router.isActive(url, { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'});
  }

  constructor(private store: Store<AppState>, private router: Router, private staticFeatureFlagService: StaticFeatureFlagService) { }

  ngOnInit(): void {
    this.isDarkModeEnabled = this.staticFeatureFlagService.isEnabled('enableDarkMode');
    this.favCount$ = this.store.pipe(select(selectFavoriteAnnouncementsCount));
    this.customerPortalUrl$ = this.store.pipe(select(selectCustomerPortalUrl));

    this.blogUrl$ = this.store.select(selectBlogPortalUrl);
    this.blogEnabled$ = this.store.select(selectBlogEnabled);
  }

  closeAllMenus(){
    this.isBurgerMenuOpen = false;
    this.isLanguageMenuOpen = false;
    this.isEmployersMenuOpen = false;
  }

  toggleBurgerMenu() {
    this.isBurgerMenuOpen = !this.isBurgerMenuOpen;
    this.isLanguageMenuOpen = false;
    this.isEmployersMenuOpen = false;
  }

  toggleLanguageMenu() {
    this.isLanguageMenuOpen = !this.isLanguageMenuOpen;
    this.isEmployersMenuOpen = false;
  }

  toggleEmployersMenu() {
    this.isEmployersMenuOpen = !this.isEmployersMenuOpen;
    this.isLanguageMenuOpen = false;
  }

  selectLanguage(language: string) {
    this.isLanguageMenuOpen = false;

    if (language === this.currentLanguage) {
      return;
    }

    this.store.dispatch(changeLanguage({ payload: { languageId: language }}));
  }

  // TODO: the apps launcher (3x3 dot grid) has no target defined in the design yet.
  onAppsLauncherClick() {
    // TODO: implement once the apps launcher content is specified.
  }

  // TODO: dark / light theme switching is not implemented yet - the button is
  // rendered per design but does not change the theme.
  toggleTheme() {
    // TODO: implement theme switching.
  }
}
